import req from './../../../../../fetch';
import { undocumentedResponse } from './../../../../../utils';
import {
  AllAPIResponses,
  CarbonError,
  NetworkType,
} from './../../../../../index';

type Params = {
  networkType: NetworkType;
};

type Payload = {
  checkInterval: number;
  confirm: boolean;
};
// TODO: this is a bad response type, should be queue depth
type FirmwareResponse = { count: number };

const post = async (
  params: Params,
  body: Payload,
  headers?: Headers
): Promise<AllAPIResponses<FirmwareResponse>> => {
  try {
    const resp = await req.post(
      `/api/claims/${params.networkType}/settings/tempcheckinterval`,
      JSON.stringify(body),
      headers
    );
    const clone = resp.clone();
    switch (resp.status) {
      case 201:
        return {
          data: (await resp.json()) as FirmwareResponse,
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default post;
